import DonationsThisWeekGraph from './DonationsThisWeekGraph';

export default DonationsThisWeekGraph;
